export const adminUser = {
  name: 'kunal singh',
  email: 'singhkunal98765@gmail.com',
  userId: '5467',
  Role: 'Admin',
  roleAndAccess: [
    {
      module: 'Brands',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Products',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Categories',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Units',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Variations',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Warehouse',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Company',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Supplier',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Warehouse Stock',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Purchase',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Purchase Invoice',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Product Package',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Roles & Permission',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Users',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Expenses',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Expense Categories',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Customers',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Customer Schedule Package',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Batch',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Shift',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'Terminal Master',
      scope: ['create', 'edit', 'delete', 'list'],
    },
    {
      module: 'CheckInOut',
      scope: ['create', 'edit', 'delete', 'list'],
    },
  ],
  isLoggedIN: true,
};
